import baseAPI from "@/api/base";
import {
  EditBucketJourney,
  GetBucketJourney,
  RegisterBucketJourney,
} from "@/dtos/BucketJourney.dto";
import {
  DELETE_BUCKET_JOURNEY_URL,
  EDIT_BUCKET_JOURNEY_URL,
  GET_BUCKET_JOURNEY_URL,
  REGISTER_BUCKET_JOURNEY_URL,
  TOGGLE_BUCKET_JOURNEY_IS_ACTIVE_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class BucketJourney {
  static getBucketJournies = async (getBucketJourney: GetBucketJourney): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_BUCKET_JOURNEY_URL, {
      params: getBucketJourney,
    });
    return response;
  };

  static registerBucketJourney = async (
    registerBucketJourney: RegisterBucketJourney
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_BUCKET_JOURNEY_URL, {
      ...registerBucketJourney,
    });
    return response;
  };

  static editBucketJourney = async (
    editBucketJourney: EditBucketJourney
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_BUCKET_JOURNEY_URL, {
      ...editBucketJourney,
    });
    return response;
  };

  static toggleBucketJourneyIsActive = async (
    editBucketJourney: EditBucketJourney
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(TOGGLE_BUCKET_JOURNEY_IS_ACTIVE_URL, {
      ...editBucketJourney,
    });
    return response;
  };

  static deleteBucketJourney = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(`${DELETE_BUCKET_JOURNEY_URL}/${id}`);
    return response;
  };
}

export default BucketJourney;
